import {replaceName} from "../../util/ReplaceText.tsx";
import {instance_manager} from "../../lib/InstanceManager.ts";
import {t} from "i18next";

const STATUS_COLOR_MAP: Record<string, string> = {
    "ACTIVE": '#264EDD',
    "SHUTOFF": '#dc3545',
    "HARD_REBOOT": '#6610f2',
    "PAUSED": '#fd7e14',
}

export const instanceRowColumnRenderHelper = {
    flavor_column(flavorId: string) {
        const flavorName = instance_manager.getFlavorName(flavorId);

        if (flavorName) {
            return `<span class='flavor' data-flavor-id='${flavorId}'>${replaceName(flavorName)}</span>`;
        }

        return `<span class='flavor' data-flavor-id='${flavorId}'>${flavorId}</span>`;
    },

    status_column(status: string) {
        const color: string = STATUS_COLOR_MAP[status] ?? "";
        return `<span style="color:${color}">${status}</span>`
    },

    ActionButton(data: number) {
        return `<div class="dropdown" data-instance="${data}">
            <button class="button_blue-sm px-2 dropdown-toggle" type="button" data-bs-toggle="dropdown"
                    aria-expanded="false">
                ${t("common.action")}
            </button>
            <div class="dropdown-menu dropdown-menu-end">
        <a class="dropdown-item restart" data-action="hard-restart">${t("instance.actions.restart")}</a>
        <a class="dropdown-item pause" data-action="pause">${t("instance.actions.pause")}</a>
        <a class="dropdown-item resume" data-action="resume">${t("instance.actions.resume")}</a>
        <a class="dropdown-item shutdown" data-action="shutdown">${t("instance.actions.shutdown")}</a>
        <a class="dropdown-item boot" data-action="boot">${t("instance.actions.boot")}</a>
        <a class="dropdown-item delete" data-action="delete">${t("instance.actions.delete")}</a>
        <a class="dropdown-item create-snapshot" data-action="create-snapshot">${t("instance.actions.createSnapshot")}</a>
        <a class="dropdown-item port-forwarding" data-action="show-port-forwarding">${t("instance.actions.portForwarding")}</a>
        <a class="dropdown-item ssh-terminal" data-action="open-web-ssh-terminal">${t("instance.actions.webSshTerminal")}</a>

                    <!-- @FIXME Backend API도 제거 필요 -->
        <!-- <a class="dropdown-item ssh-terminal" data-action="open-web-ssh-terminal-old">${t("instance.actions.webSshTerminalOld")}</a> -->
        <a class="dropdown-item console" data-action="open-vnc-console">${t("instance.actions.vncConsole")}</a>
            </div>
        </div>`
    },
    powerState(state: number) {
        switch (state) {
            case 0:
                return `<span class="pwr-state" data-state="0">No State</span>`;
            case 1:
                return `<span class="pwr-state text-primary" data-state="1">Running</span>`;
            case 3:
                return `<span class="pwr-state" style="color: #fd7e14;" data-state="3">PAUSED</span>`;
            case 4:
                return `<span class="pwr-state text-danger" data-state="4">Shut Down</span>`;
            case 6:
                return `<span class="pwr-state text-danger" data-state="6">Crashed</span>`;
            case 7:
                return `<span class="pwr-state text-warning" data-state="7">Suspended</span>`;
            default:
                return state;
        }
    },
    taskState(state: string) {
        const titleCase = (s: string) =>
            s.replace(/^_*(.)|_+(.)/g, (_, c, d) => c ? c.toUpperCase() : ' ' + d.toUpperCase())


        return `<span class="task-state" data-pending="${state ? 'y' : 'n'}">${state ? titleCase(state) : 'None'}</span>`
    },
}